import renderFundingInteractive from "../renderFundingInteractive.jsx";

document.addEventListener("DOMContentLoaded", () => {
  renderFundingInteractive();
});
